import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import locationPng from "../../assets/location.png";
import bedPng from "../../assets/bed.png";
import scalePng from "../../assets/scale.png";
import bathtubPng from "../../assets/bathtub.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { slugify } from '../../utils/slugify';

const ContentNew = ({ data }) => {
  const [index, setIndex] = useState(0);
  const [buyRealEstate, setBuyRealEstate] = useState([]);
  const [sortOrder, setSortOrder] = useState("latest");
  const propertiesPerPage = 9;
  const navigate = useNavigate();

  useEffect(() => {
    setBuyRealEstate(data.filter((property) => property.status === "approved"));
  }, [data]);

  const totalPages = Math.ceil(buyRealEstate.length / propertiesPerPage);

  const handleClick = (property) => {
    navigate(`/property/${slugify(property.name)}`);
  };

  const st = {
    display: "flex",
    justifyContent: "flex-start",
    alignTtems: "center",
    color: "var(--text-color)",
    fontWeight: "400",
    fontSize: "14px",
    margin: "24px 0",
  };

  const handleSort = (order) => {
    let sortedProperties = [...buyRealEstate];
    switch (order) {
      case "latest":
        sortedProperties.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case "max-price":
        sortedProperties.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
        break;
      case "min-price":
        sortedProperties.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
        break;
      default:
        break;
    }
    setBuyRealEstate(sortedProperties);
    setSortOrder(order);
  };

  const renderProperties = (startIndex) => {
    return buyRealEstate
      .slice(startIndex, startIndex + propertiesPerPage)
      .map((property, key) => (
        <div
          key={key}
          className="px-0 sm:px-8 pb-8 w-[90vw] md:w-[45vw] lg:w-[30vw] cursor-pointer rounded-md overflow-hidden"
          onClick={() => handleClick(property)}
        >
          <div className="border border-[#E9E9E9]-400 bg-white rounded-lg shadow-md overflow-hidden">
            <div className="relative overflow-hidden">
              <img
                src={`${property.images[0]}`}
                alt="dubaiPhoto"
                className="h-[30vh] sm:h-[40vh] object-cover w-[100%] rounded-lg duration-300 hover:scale-[1.2]"
              />
            </div>
            <div className="flex flex-col px-[3%] pb-[3%]">
              <div className="pt-4 text-xl font-semibold text-left text-black">
                {property.name}
              </div>
              <div className="mb-2 text-xs font-light text-left text-gray-500">
                {property.desc.slice(0, 100) + "..."}
              </div>
              <div className="flex flex-row-reverse items-center justify-between">
                <div className="text-left font-poppins rounded-full lg:text-md  text-[#173d73] py-1 px-4">
                  {property.price > 0 ? property.price + " AED" : "Contact Us"}
                </div>
                <div className="flex items-center py-2 text-sm text-left text-gray">
                  <img src={locationPng} alt="location" className="w-4 m-1" />
                  <div>{property.location}</div>
                </div>
              </div>
              <div className="flex items-center py-2 text-sm text-left text-gray">
                <div className="flex px-2 py-1 mr-0 text-left">
                  <button className="px-2 py-1 mr-6 text-lg font-semibold text-white bg-[#173D73] border-b-0 rounded-lg bsolute top-6">
                    <i className="fas fa-phone" />
                  </button>
                  <button className="px-2 py-1 mr-6 text-lg font-semibold text-white bg-[#173D73] rounded-lg bsolute top-6 ">
                    <i className="fab fa-whatsapp " />
                  </button>
                </div>
                <div className="flex items-center justify-center text-base font-semibold text-left md:text-lg">
                  <img
                    src={bedPng}
                    alt=""
                    className="w-1 h-1 mx-2 md:w-4 md:h-4"
                  />
                  <span>{property.bedrooms}</span>
                </div>
                <div className="flex items-center justify-center text-base font-semibold text-left md:text-lg">
                  <img
                    src={bathtubPng}
                    alt=""
                    className="w-1 h-1 mx-2 md:w-4 md:h-4"
                  />
                  <span>{property.bathrooms}</span>
                </div>
                <div className="flex items-center justify-center text-base font-semibold text-left md:text-lg">
                  <img
                    src={scalePng}
                    alt=""
                    className="w-1 h-1 mx-2 md:w-4 md:h-4"
                  />
                  <span>{property.square}</span>
                </div>
              </div>

              {/* <div className="text-left font-semibold border mt-3 rounded-lg py-2 flex items-center justify-center border-[#173d73] text-[#173d73] hover:bg-[#173d73] hover:text-white duration-500 sm:my-2 w-[100%]">
                Area Guide
              </div>*/}
            </div>
          </div>
        </div>
      ));
  };

  return (
    <div className="relative *:font-sans">
      <div className="my-5 font-semibold text-left ml-[7%] text-3xl">
        {data.length === 0 ? "No Properties Available!" : `Properties`}
      </div>
      <div className="flex flex-col flex-wrap items-center justify-center md:flex-row">
        {renderProperties(index * propertiesPerPage)}
      </div>
      <div className="relative mb-12 mx-auto flex justify-center sm:my-[2%]">
        {Array.from({ length: totalPages }, (_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            className={`mx-2 px-6 py-5 border border-black duration-300 cursor-pointer ${
              index === i
                ? "bg-black text-white"
                : "hover:bg-black hover:text-white"
            }`}
          >
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentNew;
